export const ConfigKey_SmartDocs_NoteIds = 'smart-docs__note-ids';
//# sourceMappingURL=app-config.js.map